<template>
  <div v-if="!busLines" class="d-flex justify-content-center" style="margin: 3em 0;">
    <div class="loader"></div>
  </div>
  <div v-else class="columns mx-0 busTracker">
    <div @click="search()" class="refreshBox c-hand">
      <div class="d-inline my-1 justify-content-center">
        <span>{{ getCaption('caption.bus_station_refresh') }}</span>
        <button class="btn btn-sm btn--color-purple rounded ml-2">
          <i class="fas fa-sync-alt"></i>
        </button>
      </div>
    </div>

    <div class="instructionBox">
      <div class="d-flex my-1">
        <div class="dotline__dot special"></div>
        <span>{{ getCaption('caption.bus_station_end') }}</span>
      </div>
      <div class="d-flex my-1">
        <div class="dotline__dot normal"></div>
        <span>{{ getCaption('caption.bus_station_normal') }}</span>
      </div>
    </div>

    <div class="column col-xs-12 col-sm-10 col-md-9 col-lg-8 col-6 col-mx-auto px-0">
      <div class="form-group">
        <label class="form-label">{{ getCaption("caption.choose_bus_line") }}</label>
        <select v-model="selectedBusLine" @change="search" class="form-select focus-purple">
          <option :value="null" hidden disabled>{{ getCaption("caption.choose") }}</option>
          <option
            v-for="line in busLines"
            :key="line.line_id"
            :value="line"
          >{{ line.name }}</option>
        </select>
      </div>

      <div v-if="isLoading" class="d-flex justify-content-center" style="margin: 3em 0;">
        <div class="loader"></div>
      </div>

      <div v-if="searchResult">
        <div class="busDirectionTabs">
          <div
            :class="[{'selected': selectedDirection=='start'}, 'busDirectionTab']"
            @click="setDirection('start')"
          >
            <span>{{ selectedDirection=='start' ?
              searchResult.station_list[0].station_name 
              : searchResult.station_list[searchResult.station_list.length - 1].station_name }}</span>
            <i class="fas fa-long-arrow-alt-down"></i>
            <span>{{ selectedDirection=='start' ?
              searchResult.station_list[searchResult.station_list.length - 1].station_name
              : searchResult.station_list[0].station_name }}</span>
          </div>
          <div
            :class="[{'selected': selectedDirection=='end'}, 'busDirectionTab']"
            @click="setDirection('end')"
          >
            <span>{{ selectedDirection=='start' ?
              searchResult.station_list[searchResult.station_list.length - 1].station_name
              : searchResult.station_list[0].station_name }}</span>
            <i class="fas fa-long-arrow-alt-down"></i>
            <span>{{ selectedDirection=='start' ?
              searchResult.station_list[0].station_name
              : searchResult.station_list[searchResult.station_list.length - 1].station_name }}</span>
          </div>
        </div>
        <ul class="dotline">
          <li v-for="(station, index) in searchResult.station_list" :key="station.station_id">
            <div class="dotline__busIcon">
              <i v-if="station.exist_bus=='Y'" class="fas fa-bus"></i>
              <!-- <i class="fas fa-bus" v-for="i in 10" :key="i"></i> -->
            </div>

            <div class="dotline__line"></div>
            <div
              :class="[index+1==1 || index+1 == searchResult.station_list.length ? 'special' : 'normal', 'dotline__dot']"
            >
              <i class="fas fa-angle-down"></i>
            </div>
            <div class="dotline__content">
              <span class="dotline__label">{{ station.station_name }}</span>
              <div class="size-3">
                <i
                  class="fas fa-map-marker-alt"
                  :title="getCaption('caption.card_recharge_station')"
                ></i>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleService from "@/services/ScheduleService.js";
import { transportationSchedule } from "@/constants/sidemenu.js";

export default {
  data() {
    return {
      busLines: null,
      selectedBusLine: null,
      selectedDirection: "start",
      isLoading: false,
      searchResult: null
    };
  },

  computed: {},

  mounted() {
    this.setSidemenu();
    this.getBusLines();
  },

  methods: {
    setSidemenu() {
      let title = this.getCaption("caption.bus_tracker");

      this.$store.dispatch("setSidemenuData", {
        menu: transportationSchedule,
        parentType: "topmenu",
        parentId: "bus_tracker",
        title: title
      });
    },

    getBusLines() {
      ScheduleService.getBusLines().then(response => {
        this.busLines = response.data;
      });
    },

    setDirection(dir) {
      this.selectedDirection = dir;
      this.search();
    },

    search() {
      if (!this.selectedBusLine) return;
      this.isLoading = true;
      this.searchResult = null;
      ScheduleService.getBusLineDetail(
        this.selectedBusLine.id,
        this.selectedDirection
      ).then(response => {
        this.isLoading = false;
        this.searchResult = response.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.busTracker {
  position: relative;
  min-height: 150px;
}
.busDirectionTabs {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.busDirectionTab {
  text-align: center;
  display: flex;
  flex-direction: column;
  font-size: 1.1em;
  flex-grow: 1;
  border-radius: 5px;
  padding: 0.3em 0;
  cursor: pointer;

  &.selected {
    background: $orange-color;
    color: white;
    border: none;
  }
}

.dotline {
  list-style-type: none;
  margin: 0 auto;
  // max-width: 500px;

  li {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 1em 1em 1em 5px;
    position: relative;

    &:first-child {
      .dotline__line {
        top: 50%;
      }
    }

    &:last-child {
      .dotline__line {
        bottom: 50%;
      }
    }

    &:nth-child(odd) {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.dotline__line {
  position: absolute;
  width: 2px;
  height: 100%;
  // top: 50%;
  left: 54px;
  background: #767676;
  z-index: 1;
}

.dotline__content {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (min-width: $breakpoint-sm) {
  .instructionBox,
  .refreshBox {
    width: 100%;
    display: flex;
    justify-content: center;

    div {
      margin: 0 1em;
    }
  }
}

@media (min-width: $breakpoint-lg) {
  .instructionBox {
    position: absolute;
    right: 0;
    width: auto;
    display: block;
    margin-top: 2.5em;
  }
  .refreshBox {
    position: absolute;
    left: 0;
    width: auto;
    display: block;
    margin-top: 2.5em;
  }
}
</style>
